export enum ExportTypeEnum {
    excel,
    json
}
